// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o7OCpPe5Lv9U2ZIFNKbg{display:flex;flex-wrap:wrap;margin:-6px;overflow:hidden}.Z2s4FYNtQxIW0QoJecVV{flex-grow:0;font-size:12px !important;font-weight:bold;line-height:14px;margin:0 0 12px 0;padding:0}.r4N2NCC849NMZa_Z4pth{color:#fff}.m8lwLdEMw9dhXxmS3kcM{color:#1e0c1b}.k10cF2lvlKoczGqXd1fP{box-sizing:border-box;padding:6px;width:33%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardList": `o7OCpPe5Lv9U2ZIFNKbg`,
	"menuTitle": `Z2s4FYNtQxIW0QoJecVV`,
	"menuTitleDark": `r4N2NCC849NMZa_Z4pth`,
	"menuTitleLight": `m8lwLdEMw9dhXxmS3kcM`,
	"wikiCardWrapper": `k10cF2lvlKoczGqXd1fP`
};
export default ___CSS_LOADER_EXPORT___;
